module.exports = __webpack_public_path__ + "static/media/20.6707b833.jpg";